'use client';

import {useEffect, useCallback} from 'react';
import {useSearchParams} from 'next/navigation';
import {signIn} from 'next-auth/react';
import {Button} from '@manaboo/ui/button';
import {RobloxSignet} from '@manaboo/ui/icons';
import {referrals} from '@manaboo/lib/referrals';

interface ButtonsAuthProps {
	isTestEnv?: boolean;
}

interface ButtonConfig {
	label: string;
	variant?: 'default' | 'outline';
	icon?: React.ReactNode;
}

export function ButtonsAuth({isTestEnv = false}: ButtonsAuthProps) {
	const searchParams = useSearchParams();
	const referralId = searchParams.get('referralId');
	const userId = searchParams.get('userId');

	useEffect(() => {
		if (referralId) {
			referrals.setReferralCookie(referralId);
		}
	}, [referralId]);

	const handleSignIn = useCallback(() => {
		if (isTestEnv && userId) {
			return signIn('test', {userId});
		}
		return signIn('roblox');
	}, [isTestEnv, userId]);

	const buttons: ButtonConfig[] = [
		{label: 'Zarejestruj się', icon: <RobloxSignet className="mr-2 h-4 w-4" />},
		{label: 'Zaloguj się', variant: 'outline'},
	];

	return (
		<div className="flex max-w-[350px] flex-col gap-3">
			{buttons.map(({label, variant = 'default', icon}) => (
				<Button
					className="w-full text-lg"
					key={label}
					onClick={handleSignIn}
					size="lg"
					variant={variant}
				>
					{icon ? icon : null}
					{label}
				</Button>
			))}
		</div>
	);
}
